import BookmarkIcon from "@assets/svg/BookmarkIcon";
import BriefcaseIcon from "@assets/svg/BriefcaseIcon";
import dayjs from "@lib/dayjs";

const posts = [
  {
    icon: <BriefcaseIcon className="w-6 h-6" />,
    desc: "Business Development Executive",
    count: 12,
  },
  {
    icon: <BriefcaseIcon className="w-6 h-6" />,
    desc: "Mean Stack Developer Manager",
    count: 24,
  },
  {
    icon: <BriefcaseIcon className="w-6 h-6" />,
    desc: "Lead Generation Executive",
    count: 20,
  },
  {
    icon: <BriefcaseIcon className="w-6 h-6" />,
    desc: "UI/UX Designer ",
    count: 8,
  },
];

const RecentJobPosts = () => {
  return (
    <div className="flex flex-col flex-1 min-h-0">
      <div className="flex items-center justify-between">
        <span className="font-bold text-primary text-sm">Recent Job Posts</span>
        <button className="font-semibold text-blue-500 text-xs">
          Manage Jobs
        </button>
      </div>{" "}
      {/* List Section */}
      <div className="mt-5 flex flex-col gap-5 min-h-0 overflow-y-scroll no-scrollbar">
        {posts?.map((post, postIndex) => {
          return (
            <div key={postIndex} className="flex items-center gap-3.5">
              <div className="flex items-center justify-center w-11 h-11 rounded-md bg-gray-100">
                <BriefcaseIcon className="w-6 h-6" />
              </div>
              <div className="flex flex-col justify-between flex-1 gap-2">
                <span className="text-xs font-medium">{post?.desc}</span>
                <div className="flex items-center gap-10">
                  <span className="text-xs text-light-black">
                    Posted date: {dayjs().format("DD MMM YY")}
                  </span>
                  <span className="text-xs text-light-black">
                    Application Count: {post?.count}
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RecentJobPosts;
